import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';
import { FormControl } from '@angular/forms';
import { Observable, ReplaySubject } from 'rxjs';

@Component({
selector: 'app-user-creation',
templateUrl: './user-creation.component.html',
styleUrls: ['./user-creation.component.scss']
})
export class UserCreationComponent implements OnInit {

	@BlockUI() blockUI: NgBlockUI;
	@Input() role: string;

	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	nameOrganization: string;
	password: string;
	address: string;
	codePostal: string;
	city: string;
	country: string;
	lat: number;
	long: number;
	description: string;
	subDomainName: string;
	isWeb: boolean;
    isPriseCote: boolean;
	isFitting: boolean;
	networks: any;
	networkList: string[] = ["SM", "MDM"];

	imageUpload: File;
	logo: any;
	isValidImage: boolean;

	regex = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).{8,20}$/;

	constructor(
		public activeModal: NgbActiveModal,
		private toastrService: ToastrService,
		private usersService: UsersService,
	) { }

	ngOnInit(): void {
	}

	filterFitting(e): void{
		const filter = e.value;
		if (filter === "isFitting"){
			this.isFitting = true;
			return;
		}
		this.isFitting = false;
	}

	filterWeb(e): void{
		const filter = e.value;
		if (filter === "isWeb"){
			this.isWeb = true;
			return;
		}
		this.isWeb = false;
	}

    filterPriseCote(e): void{
        const filter = e.value;
		if (filter === "isPriseCote"){
			this.isPriseCote = true;
			return;
		}
		this.isPriseCote = false;
    }

	checkPasswordValidation(value) {

        const isWhitespace = /^(?=.*\s)/;
        if (isWhitespace.test(value)) {
          return "ne doit pas contenir d'espace";
        }
    
    
        const isContainsUppercase = /^(?=.*[A-Z])/;
        if (!isContainsUppercase.test(value)) {
          return "doit contenir au moins une lettre majuscule";
        }
    
    
        const isContainsLowercase = /^(?=.*[a-z])/;
        if (!isContainsLowercase.test(value)) {
          return "doit contenir au moins lettre minuscule";
        }
    
    
        const isContainsNumber = /^(?=.*[0-9])/;
        if (!isContainsNumber.test(value)) {
          return "doit contenir un chiffre.";
        }
    
    
        const isContainsSymbol =
          /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹])/;
        if (!isContainsSymbol.test(value)) {
          return "doit contenir un caractère spéciaux";
        }
    
    
        const isValidLength = /^.{8,20}$/;
        if (!isValidLength.test(value)) {
          return "doit contenir entre 8 et 20 caractères";
        }

		return null;
    }

	processImage(event) {
		let isValidImage = document.getElementById('isValidImage');
		let isNotValidImage = document.getElementById('isNotValidImage');

		isValidImage.style.display = "none";
		isNotValidImage.style.display = "none";

		let image: File = event.target.files[0];
		if (image.size <= 5 * 2 ** 20) {
			this.imageUpload = image;
			isValidImage.style.display = "block";
		}
		else {
			isNotValidImage.style.display = "block";
		}
	}

	addUser(): void{
		this.blockUI.start('Loading');

		let resultPasswordValidation = this.checkPasswordValidation(this.password)

		if (resultPasswordValidation) {
			console.log(this.password);
			console.log(this.regex.test(this.password));
			this.toastrService.error(`le mot de passe ${resultPasswordValidation}`);
			this.blockUI.stop();
			return;
		}

		if (this.role === 'Provider'){
			// createProvider
			// const data = {
			// 	jwt: localStorage.getItem('token'),
			// 	firstName: this.firstName,
			// 	lastName: this.lastName,
			// 	phone: this.phone,
			// 	email: this.email,
			// 	password: this.password,
			// 	city: this.city,
			// 	name: this.nameOrganization,
			// 	description: this.description,
			// 	address: this.address,
			// 	postcode: this.codePostal,
			// 	country: this.country,
			// 	latitude: this.lat,
			// 	longitude: this.long,
			// 	network: this.networks,
			// 	logo: this.logo
			// }		
			
			let data: FormData = new FormData();
			data.append("jwt", localStorage.getItem('token'));
			data.append("firstName", this.firstName);
			data.append("lastName", this.lastName);
			data.append("phone", this.phone);
			data.append("email", this.email);
			data.append("password", this.password);
			data.append("city", this.city);
			data.append("name", this.nameOrganization);
			data.append("description", this.description);
			data.append("address", this.address);
			data.append("postcode", this.codePostal);
			data.append("country", this.country);
			data.append("latitude", this.lat.toString());
			data.append("longitude", this.long.toString());
			data.append("network", this.networks);
			data.append("logo", this.imageUpload);

			this.usersService.createProvider(data).subscribe(
				(res) => {
					if (res.success){
						this.toastrService.success('Un fournisseur est crée');
						this.blockUI.stop();
						this.activeModal.close();
					}
					else{
						this.blockUI.stop();
						if (res.errorSet.includes('INVALID_PARAMS')) {
							this.toastrService.error('Les paramètres sont invalides');
						} else if (res.errorSet.includes('INVALID_REQUEST')) {
							this.toastrService.error("Les paramètres sont manquants");
						} else if (res.errorSet.includes('USER_NOT_EXIST')) {
							this.toastrService.error("Le créateur n'existe pas");
						} else if (res.errorSet.includes('EMAIL_EXIST')) {
							this.toastrService.error("L'email existe déjà");
						} else if (res.errorSet.includes('ORG_APP_EXIST')) {
							this.toastrService.error("Le fournisseur existe déjà");
						} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
							this.toastrService.error('Une erreur serveur est survenue');
						}
					}
				},
				(error) => {
					this.blockUI.stop();
					// console.error(error);
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
		else if (this.role === 'Shop'){
			// createShop
			// const data = {
			// 	jwt: localStorage.getItem('token'),
			// 	firstName: this.firstName,
			// 	lastName: this.lastName,
			// 	phone: this.phone,
			// 	email: this.email,
			// 	password: this.password,
			// 	city: this.city,
			// 	name: this.nameOrganization,
			// 	description: this.description,
			// 	address: this.address,
			// 	postcode: this.codePostal,
			// 	country: this.country,
			// 	latitude: this.lat,
			// 	longitude: this.long,
			// 	network: [this.networks],
			// 	isWeb: this.isWeb,
			// 	isFitting: this.isFitting,
			// 	subDomainName: this.subDomainName,
			// }

			let data: FormData = new FormData();
			data.append("jwt", localStorage.getItem('token'));
			data.append("firstName", this.firstName);
			data.append("lastName", this.lastName);
			data.append("phone", this.phone);
			data.append("email", this.email);
			data.append("password", this.password);
			data.append("city", this.city);
			data.append("name", this.nameOrganization);
			data.append("description", this.description);
			data.append("address", this.address);
			data.append("postcode", this.codePostal);
			data.append("country", this.country);
			data.append("latitude", this.lat.toString());
			data.append("longitude", this.long.toString());
			data.append("network", this.networks);
			data.append("logo", this.imageUpload);
			data.append("isWeb", this.isWeb.toString());
			data.append("isPriseCote", this.isPriseCote.toString());
			data.append("isFitting", this.isFitting.toString());
			data.append("subDomainName", this.subDomainName);

			this.usersService.createShop(data).subscribe(
				(res) => {
					if (res.success){
						this.toastrService.success('Une boutique est crée');
						this.blockUI.stop();
						this.activeModal.close();
					}
					else{
						this.blockUI.stop();
						if (res.errorSet.includes('INVALID_PARAMS')) {
							this.toastrService.error('Les paramètres sont invalides');
						} else if (res.errorSet.includes('INVALID_REQUEST')) {
							this.toastrService.error("Les paramètres sont manquants ou incorrecte");
						} else if (res.errorSet.includes('USER_NOT_EXIST')) {
							this.toastrService.error("Le créateur n'existe pas");
						} else if (res.errorSet.includes('EMAIL_EXIST')) {
							this.toastrService.error("L'email existe déjà");
						} else if (res.errorSet.includes('ORG_APP_EXIST')) {
							this.toastrService.error("La boutique existe déjà");
						} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
							this.toastrService.error('Une erreur serveur est survenue');
						} else {
							this.toastrService.error('Une erreur serveur est survenue');
						}
					}
				},
				(error) => {
					this.blockUI.stop();
					// console.error(error);
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
	}
}
